import IconBase from '@/frontend/components/icons/IconBase';
export default {
  name: "LoupeIcon",
  props: {
    width: {
      type: [Number, String],
      default: 15
    },
    height: {
      type: [Number, String],
      default: 15
    }
  },
  components: {
    IconBase
  }
};